import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Label,
  Input,
  Button,
  Table
} from "reactstrap";

const PaperRA = () => {
  const [form, setForm] = useState({
    raDate: "",
    raType: "Medical aid",
    raNumber: "",
    paymentDate: "",
    scheme: "",
    eftReference: "",
    totalPaid: 0,
    journalTotal: 0,
    outstandingOnly: true
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value
    });
  };

  return (
    <Container fluid>
      <Card>
        <CardBody>

           <h5>Capture Paper RA</h5>

          <Row className="mt-3">
            {/* Left column */}
            <Col md={6}>
              <FormGroup>
                <Label>RA/statement date</Label>
                <Input
                  type="date"
                  name="raDate"
                  value={form.raDate}
                  onChange={handleChange}
                />
              </FormGroup>

              <FormGroup>
                <Label>RA/statement type</Label>
                <Input
                  type="select"
                  name="raType"
                  value={form.raType}
                  onChange={handleChange}
                >
                  <option>Medical aid</option>
                  <option>Other type</option>
                </Input>
              </FormGroup>

              <FormGroup>
                <Label>RA/statement no.</Label>
                <Input
                  type="text"
                  name="raNumber"
                  value={form.raNumber}
                  onChange={handleChange}
                />
              </FormGroup>

              <FormGroup>
                <Label>Total paid</Label>
                <Input
                  type="number"
                  name="totalPaid"
                  value={form.totalPaid}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>

            {/* Right column */}
            <Col md={6}>
              <FormGroup>
                <Label>Payment date</Label>
                <Input
                  type="date"
                  name="paymentDate"
                  value={form.paymentDate}
                  onChange={handleChange}
                />
              </FormGroup>

              <FormGroup>
                <Label>Scheme</Label>
                <Input
                  type="select"
                  name="scheme"
                  value={form.scheme}
                  onChange={handleChange}
                >
                  <option>Nothing selected</option>
                  <option>Scheme A</option>
                  <option>Scheme B</option>
                </Input>
              </FormGroup>

              <FormGroup>
                <Label>EFT reference no.</Label>
                <Input
                  type="text"
                  name="eftReference"
                  value={form.eftReference}
                  onChange={handleChange}
                />
              </FormGroup>

              <FormGroup>
                <Label>Journal total</Label>
                <div className="d-flex align-items-center">
                  <span className="me-2">R {form.journalTotal.toFixed(2)}</span>
                  <Button size="sm" color="success">
                    Edit journal amount
                  </Button>
                </div>
              </FormGroup>
            </Col>
          </Row>

          {/* Allocated / Remaining */}
          <Row className="mt-3">
            <Col>
              <strong>
                Allocated: R 0.00 / Remaining: R 0.00
              </strong>
            </Col>
          </Row>

          {/* Table */}
          <Row className="mt-3">
            <Col>
              <Table bordered size="sm">
                <thead>
                  <tr>
                    <th>Member No.</th>
                    <th>Account No.</th>
                    <th>Account Holder</th>
                    <th>Amount Paid</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colSpan={4}>
                      <Input
                        type="text"
                        placeholder="Search on name, surname, account no., or member no."
                      />
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>

          {/* Footer row */}
          <Row className="mt-2 align-items-center">
            <Col md={6}>
              Allocated to account: R 0.00
            </Col>
            <Col md={6} className="text-end">
              <Input
                type="checkbox"
                name="outstandingOnly"
                checked={form.outstandingOnly}
                onChange={handleChange}
              />{" "}
              Outstanding balances only
            </Col>
          </Row>

          {/* Buttons */}
          <Row className="mt-4">
            <Col className="d-flex justify-content-end">
              <Button color="secondary" className="me-2">
                Clear
              </Button>
              <Button color="secondary" className="me-2">
                Close
              </Button>
              <Button color="warning" className="me-2">
                Save for later
              </Button>
              <Button color="primary">Save</Button>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Container>
  );
};

export default PaperRA;
